export default __webpack_public_path__ + "static/media/ic-transfer-in-transit-info.d54188b9.svg";